import "@/styles/index.css";

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import { pillMarker } from "@/scripts/alpine/pill-marker";
import collapse from '@alpinejs/collapse'
import mobileBar from "@/scripts/components/mobile-bar";
import siteHeader from "@/scripts/components/site-header";
import siteMenu from "@/scripts/components/site-menu";
import modal from "@/scripts/components/modal";
import form from "@/scripts/components/form/form";
import mediaSlider from "@/scripts/components/media-slider";
import scrollReveal from "@/scripts/components/scroll-reveal";
import scrollTo from "@/scripts/components/scroll-to";
import paginatedList from "@/scripts/components/paginated-list";
import sliders from "@/scripts/components/sliders";
import slideToggle from "@/scripts/components/slide-toggle";
import card from "@/scripts/components/info-card";

window.Alpine = Alpine;

mobileBar.init();
siteHeader.init();
siteMenu.init();
modal.init();
form.init();
mediaSlider.init();
scrollReveal.init();
scrollTo.init();
paginatedList.init();
sliders.init();
slideToggle.init();
card.init();

Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.data("pillMarker", pillMarker);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});
